import { CartesianGrid, XAxis, YAxis, Tooltip, ResponsiveContainer, Area, AreaChart } from "recharts";

import { useQuery } from "@apollo/client";

import { GET_COUNT_HISTORY } from "../../queries";
import { timestampFormatTime } from "../../helpers/timestampFormat";

interface CountHistoryChartProps {
	DeviceID: number;
	CountSummaryID: number;
	StaticRate: string;
	pollingInterval: number;
}

const CountLineChart = ({ DeviceID, CountSummaryID, StaticRate, pollingInterval }: CountHistoryChartProps) => {
	const { data } = useQuery(GET_COUNT_HISTORY, {
		variables: { DeviceID: DeviceID, CountSummaryID: CountSummaryID },
		notifyOnNetworkStatusChange: true,
		pollInterval: pollingInterval * 1000,
	});

	if (!data || data.length < 2) return <span>Waiting For Data....</span>;

	//console.log("data", data);
	let prevValue = -1;
	let prevTime = -1;
	let chartData = data.countcCountHistory.map((d: any) => {
		if (prevValue === -1) {
			prevValue = d.Quantity;
			prevTime = Number(d.CreateDate);
			return {};
		}
		let elapsedTime = Number((Number(d.CreateDate) - prevTime) / 1000);
		//if current count is less than last count then just use 0, mostly to give time for the count to be reset or catch back up from an adjustment
		let curentCount = d.Quantity < prevValue ? 0 : Number(d.Quantity - prevValue);
		let ret = {
			CreateDate: timestampFormatTime(Number(d.CreateDate)),
			CurrentRate: elapsedTime > 0 ? Number(Number((curentCount / elapsedTime) * 60).toFixed(2)) : 0,
			TargetRate: Number(StaticRate),
		};
		prevValue = d.Quantity;
		prevTime = Number(d.CreateDate);
		return ret;
	});

	chartData.shift();

	//console.log("chart data", chartData);

	return (
		<ResponsiveContainer width="100%" height={160}>
			<AreaChart data={chartData} margin={{ top: 10, right: 30, left: 0, bottom: 0 }}>
				<defs>
					<linearGradient id="colorPv" x1="0" y1="0" x2="0" y2="1">
						<stop offset="5%" stopColor="#82ca9d" stopOpacity={0.8} />
						<stop offset="95%" stopColor="#82ca9d" stopOpacity={0} />
					</linearGradient>
					<linearGradient id="colorUv" x1="0" y1="0" x2="0" y2="1">
						<stop offset="5%" stopColor="#777777" stopOpacity={0.8} />
						<stop offset="95%" stopColor="#777777" stopOpacity={0} />
					</linearGradient>
				</defs>
				<XAxis dataKey="CreateDate" />
				<YAxis />
				<CartesianGrid strokeDasharray="3 3" />
				<Tooltip />
				<Area type="monotone" dataKey="TargetRate" stroke="#8884d8" fillOpacity={1} fill="url(#colorUv)" />
				<Area type="monotone" dataKey="CurrentRate" stroke="#8884d8" fillOpacity={1} fill="url(#colorPv)" />
			</AreaChart>
		</ResponsiveContainer>
	);
};

export default CountLineChart;
